import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgLinkedin(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      viewBox: "0 0 39.72 39.72",
      fill: "currentColor",
      children: [/*#__PURE__*/jsx("path", {
        d: "M23.48 17a3.15 3.15 0 00-2.88 1.59v-1.32h-3.21c.05.9 0 9.63 0 9.63h3.21v-5.38a2.14 2.14 0 01.1-.79 1.76 1.76 0 011.64-1.17c1.16 0 1.62.89 1.62 2.18v5.16h3.21v-5.53c0-3-1.58-4.33-3.69-4.33zm-2.89 1.62zm-8.17-1.35h3.2v9.63h-3.2z"
      }), /*#__PURE__*/jsx("path", {
        d: "M19.86 0a19.86 19.86 0 1019.86 19.86A19.88 19.88 0 0019.86 0zm10.53 28.84a1.55 1.55 0 01-1.57 1.53H10.76a1.55 1.55 0 01-1.57-1.53V10.57A1.56 1.56 0 0110.76 9h18.06a1.55 1.55 0 011.57 1.53zm0 0"
      }), /*#__PURE__*/jsx("path", {
        d: "M14 12.62A1.67 1.67 0 1014 16a1.67 1.67 0 100-3.33zm0 0"
      })]
    })
  }));
}

export { SvgLinkedin as default };
